import { useFormik } from "formik";
import Header from "../../component/Header";
import Layout from "../../component/Layout";
import * as Yup from "yup";
import * as S from "./information.styles";
import SelectComponent from "../../common/textFeilds/SelectComponent";
import UsePagination from "../../component/pagination";
import TextField from "../../common/textFeilds/textFeild";
import "./style.css";
import { p2e } from "../../common/price";

const Information = ({ step, setStep }) => {
  const nationaltyOption = [
    { title: " یک گزینه را وارد کنید", value: "" },
    { title: "خانم", value: "Female" },
    { title: "آقا", value: "Male" },
  ];
  //1.
  const initialValues = {
    gender: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].gender
      : "",
    age: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? p2e(JSON.parse(localStorage.getItem("infoPerson"))[step - 1].age)
      : "",
    height: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? p2e(JSON.parse(localStorage.getItem("infoPerson"))[step - 1].height)
      : "",
    Weight: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? p2e(JSON.parse(localStorage.getItem("infoPerson"))[step - 1].Weight)
      : "",
    bellySize: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? p2e(JSON.parse(localStorage.getItem("infoPerson"))[step - 1].bellySize)
      : "",
  };

  //2.
  const onSubmit = (values) => {
    const datas = JSON.parse(localStorage.getItem("infoPerson"));
    let info = localStorage.getItem("infoPerson");
    if (info) {
      let parseInfo = JSON.parse(info);
      parseInfo[1] = values;

      localStorage.setItem("infoPerson", JSON.stringify(parseInfo));
    } else {
      datas.push(values);
      localStorage.setItem("infoPerson", JSON.stringify(datas));
    }

    localStorage.setItem("step", JSON.stringify(step));
    setStep(
      parseInt(localStorage.getItem("step"))
        ? parseInt(localStorage.getItem("step")) + 1
        : 2
    );
  };

  //3.
  const validationSchema = Yup.object({
    gender: Yup.string().required("جنسیت را وارد کنید"),
    age: Yup.number()
      .required("سن را وارد کنید")
      .min(18, "سن شما باید بالاتر از 18 سال  باشد")
      .max(120, "سن شما باید کمتر از  120 سال باشد")
      .typeError("اعداد را به لاتین وارد کنید"),
    height: Yup.number()
      .min(100, "قد شما باید بالاتر از 100 سانتی متر  باشد")
      .max(230, "قد شما باید کمتر از  230 سانتی متر  باشد")
      .required(" قد را وارد کنید"),
    // .typeError("اعداد را به لاتین وارد کنید"),

    Weight: Yup.number()
      .min(30, "وزن شما باید بالاتر از 30 کیلو گرم  باشد")
      .max(200, "وزن شما باید کمتر از  200 کیلوگرم باشد")
      .integer()
      .nullable(true)
      // .typeError("اعداد را به لاتین وارد کنید")

      .required("وزن را وارد کنید"),
    bellySize: Yup.number(),
    // .typeError("اعداد را به لاتین وارد کنید"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });
  const handleChange = (e, fieldName) => {
    console.log(formik.values.fullname);

    console.log("changing", e.target.value, formik.values);
    formik.setFieldValue(fieldName, p2e(e.target.value));
  };

  return (
    <>
      <Header>
        <S.BgHeader style={{ backgroundImage: `url("images/header.png")` }}>
          <S.ParentImgHeader>
            <img src="/images/info.png" alt="info" width={100} />
          </S.ParentImgHeader>
        </S.BgHeader>
      </Header>
      <Layout>
        <S.Container>
          <S.InformationTitle>اطلاعات شخصی</S.InformationTitle>
          <form onSubmit={formik.handleSubmit} style={{ marginBottom: "98px" }}>
            <S.FormWrapper>
              <S.InputContainer>
                <S.Lable>
                  جنسیت
                  <S.Requierd>*</S.Requierd>
                </S.Lable>
                <SelectComponent
                  formik={formik}
                  name={`gender`}
                  selectOption={nationaltyOption}
                />

                <S.ErrorMessage>
                  {formik.errors["gender"] && formik.touched["gender"] && (
                    <div className="error">{formik.errors["gender"]}</div>
                  )}
                </S.ErrorMessage>
              </S.InputContainer>
              <S.InputContainer>
                <S.Lable>
                  سن
                  <S.Requierd>*</S.Requierd>
                </S.Lable>
                <TextField
                  input
                  placeholder="سال"
                  type={"text"}
                  style={{ direction: "ltr" }}
                  formik={formik}
                  name={"age"}
                  handleChange={handleChange}
                  fieldName={"age"}
                />
                {/* <S.InputField
                  placeholder="سال"
                  style={{ direction: "ltr" }}
                  type={"text"}
                  {...formik.getFieldProps("age")}
                  name={"age"}
                  defaultValue={""}
                /> */}

                <S.ErrorMessage>
                  {formik.errors["age"] && formik.touched["age"] && (
                    <div className="error">{formik.errors["age"]}</div>
                  )}
                </S.ErrorMessage>
              </S.InputContainer>
              <S.InputContainer>
                <S.Lable>
                  قد
                  <S.Requierd>*</S.Requierd>
                </S.Lable>
                {/* <S.InputField
                  placeholder="سانتی متر"
                  style={{ direction: "ltr" }}
                  type={"text"}
                  {...formik.getFieldProps("height")}
                  name={"height"}
                  defaultValue={"cm"}
                /> */}
                <TextField
                  input
                  unit={"cm"}
                  placeholder={"سانتی متر"}
                  type={"text"}
                  formik={formik}
                  name={"height"}
                  handleChange={handleChange}
                  fieldName={"height"}
                />

                <S.ErrorMessage>
                  {formik.errors["height"] && formik.touched["height"] && (
                    <div className="error">{formik.errors["height"]}</div>
                  )}
                </S.ErrorMessage>
              </S.InputContainer>
              <S.InputContainer>
                <S.Lable>
                  وزن
                  <S.Requierd>*</S.Requierd>
                </S.Lable>
                {/* <S.InputField
                  placeholder=" کیلو گرم"
                  style={{ direction: "ltr" }}
                  type={"text"}
                  {...formik.getFieldProps("Weight")}
                  name={"Weight"}
                /> */}
                <TextField
                  input
                  unit={"kg"}
                  placeholder={"کیلو گرم"}
                  type={"text"}
                  formik={formik}
                  name={"Weight"}
                  handleChange={handleChange}
                  fieldName={"Weight"}
                />

                <S.ErrorMessage>
                  {formik.errors["Weight"] && formik.touched["Weight"] && (
                    <div className="error">{formik.errors["Weight"]}</div>
                  )}
                </S.ErrorMessage>
              </S.InputContainer>
              <S.InputContainer>
                <S.Lable>
                  اندازه دور شکم{" "}
                  <span style={{ fontSize: "12px" }}>
                    (پر کردن این مورد الزامی نیست)
                  </span>
                </S.Lable>

                <TextField
                  input
                  unit={"cm"}
                  placeholder={"سانتی متر"}
                  type={"text"}
                  formik={formik}
                  name={"bellySize"}
                  handleChange={handleChange}
                  fieldName={"bellySize"}
                />

                <S.ErrorMessage>
                  {formik.errors["bellySize"] &&
                    formik.touched["bellySize"] && (
                      <div className="error">{formik.errors["bellySize"]}</div>
                    )}
                </S.ErrorMessage>
              </S.InputContainer>
            </S.FormWrapper>
            <UsePagination step={step} setStep={setStep} formik={formik} />
          </form>
        </S.Container>
      </Layout>
    </>
  );
};

export default Information;
